var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfFormControlBox", {
    staticClass: "ds-radio-box",
    attrs: {
      owner: _vm._self,
      "block-class": {
        border: _vm.border || _vm.isButton,
        "ds-radio-box-readonly__disabled": _vm.$disabled,
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "simple",
          fn: function () {
            return [
              _c(
                "DsfTextProxy",
                _vm._b(
                  {
                    attrs: { "show-label": false },
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  },
                  "DsfTextProxy",
                  _vm._self.$props,
                  false
                )
              ),
              _vm._t("error", function () {
                return [
                  _vm.errors.length
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(_vm._s(_vm.errorsMsg)),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              _vm.readOnly && !_vm.readOnlyNotShowDiv
                ? [
                    _c(
                      "div",
                      { staticClass: "ds-form-readonly" },
                      [
                        _c(
                          "DsfTextProxy",
                          _vm._b(
                            {
                              attrs: { "show-label": false },
                              model: {
                                value: _vm.value,
                                callback: function ($$v) {
                                  _vm.value = $$v
                                },
                                expression: "value",
                              },
                            },
                            "DsfTextProxy",
                            _vm._self.$props,
                            false
                          )
                        ),
                      ],
                      1
                    ),
                  ]
                : [
                    _vm.showModel === "text"
                      ? [
                          _c("el-input", {
                            class: { "ds-error-border": _vm.errors.length > 0 },
                            attrs: {
                              placeholder: _vm.placeholder,
                              disabled: _vm.$disabled,
                            },
                            on: {
                              change: _vm.inputChangeHandler,
                              focus: _vm.inputFocusHandler,
                              blur: _vm.inputBlurHandler,
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                return _vm.keyupHandler($event)
                              },
                            },
                            model: {
                              value: _vm.inputValue,
                              callback: function ($$v) {
                                _vm.inputValue = $$v
                              },
                              expression: "inputValue",
                            },
                          }),
                          _vm._t(
                            "append-input",
                            function () {
                              return [
                                _vm.attachOptions[_vm.inputValue] !== void 0
                                  ? _c("el-input", {
                                      class: { "is-bordered": _vm.border },
                                      style: {
                                        width: _vm.attachWidth,
                                        maxWidth: "100%",
                                      },
                                      attrs: {
                                        value:
                                          _vm.attachOptions[_vm.inputValue],
                                        disabled: _vm.$disabled,
                                        size: "small",
                                        placeholder:
                                          "请输入" + _vm.inputValue + "的内容",
                                        title:
                                          "请输入" + _vm.inputValue + "的内容",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setAttach(
                                            _vm.inputValue,
                                            $event
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                            { owner: _vm.owner }
                          ),
                        ]
                      : _vm.isButton
                      ? _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.$disabled },
                            on: { change: _vm.selectChange },
                            model: {
                              value: _vm.selectValue,
                              callback: function ($$v) {
                                _vm.selectValue = $$v
                              },
                              expression: "selectValue",
                            },
                          },
                          [
                            _vm._l(_vm.realItems, function (item, index) {
                              return [
                                _c(
                                  "el-radio-button",
                                  {
                                    key: index,
                                    ref: "radio",
                                    refInFor: true,
                                    attrs: {
                                      label: item[_vm.valueField],
                                      disabled: _vm.itemDisabled(item),
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.itemClick(item, index)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.getLabelText(item)))]
                                ),
                              ]
                            }),
                          ],
                          2
                        )
                      : [
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: _vm.$disabled },
                                on: { change: _vm.selectChange },
                                model: {
                                  value: _vm.selectValue,
                                  callback: function ($$v) {
                                    _vm.selectValue = $$v
                                  },
                                  expression: "selectValue",
                                },
                              },
                              [
                                _c("deep-loop-item", {
                                  attrs: {
                                    tag: "el-radio",
                                    direction: _vm.direction,
                                    level: 0,
                                    owner: _vm._self,
                                    items: _vm.realItems,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                        ],
                  ],
              _vm._t("error", function () {
                return [
                  _vm.errors.length
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(_vm._s(_vm.errorsMsg)),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }